import { Component, Input, OnInit } from '@angular/core';
import { PromoCode, PromoCodeType } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-promo-codes-edit-restrictions',
  templateUrl: './promo-codes-edit-restrictions.component.html',
  styleUrls: ['./promo-codes-edit-restrictions.component.scss'],
})
export class PromoCodesEditRestrictionsComponent implements OnInit {
  @Input() promoCode: PromoCode;
  PromoCodeType = PromoCodeType;

  constructor() { }

  ngOnInit(): void { }

  positiveValueCheck(propertyPath: string) {
    const properties = propertyPath.split('.');
    let obj = this;
    for (let i = 0; i < properties.length - 1; i++) {
      obj = obj[properties[i]];
    }

    if (obj[properties[properties.length - 1]] < 0) {
      obj[properties[properties.length - 1]] = null;
    }
  }

  formatDate(date: string) {
    return `${date} 00:00:00`;
  }
}
